<div class="modal-body text-center p-4">
  <sb-loading></sb-loading>
  <p class="mt-3 mb-0" [innerHTML]="message | translate"></p>
</div>
